// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2NZvm","title":"BackImages_title__3T4HZ","images":"BackImages_images__2idY2"};